import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppButton = () => {
  const whatsappNumber = '972566007288'; // ← ضع رقم الواتساب بدون +
  const message = encodeURIComponent('مرحباً! أود التحدث معكم 👋');

  // ✅ حجم الزر يختلف حسب نوع الجهاز
  const getButtonSize = () => (window.innerWidth < 768 ? 48 : 64);

  const [buttonSize, setButtonSize] = useState(getButtonSize);

  // ✅ الموضع الابتدائي
  const [position, setPosition] = useState(() => {
    const saved = localStorage.getItem('whatsappButtonPos');
    const size = getButtonSize();
    return saved
      ? JSON.parse(saved)
      : { x: window.innerWidth - size - 16, y: window.innerHeight / 2 - size / 2 };
  });

  // ✅ تحديث الحجم عند تغيير عرض الشاشة
  useEffect(() => {
    const handleResize = () => {
      const newSize = getButtonSize();
      setButtonSize(newSize);
      setPosition((prev) => {
        const maxX = window.innerWidth - newSize - 10;
        const maxY = window.innerHeight - newSize - 10;
        return {
          x: Math.min(Math.max(10, prev.x), maxX),
          y: Math.min(Math.max(10, prev.y), maxY),
        };
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // ✅ حفظ الموضع في localStorage
  useEffect(() => {
    localStorage.setItem('whatsappButtonPos', JSON.stringify(position));
  }, [position]);

  // ✅ منع الخروج من الشاشة
  const handleDrag = (event, info) => {
    const maxX = window.innerWidth - buttonSize - 10;
    const maxY = window.innerHeight - buttonSize - 10;
    const newX = Math.min(Math.max(10, info.point.x), maxX);
    const newY = Math.min(Math.max(10, info.point.y), maxY);
    setPosition({ x: newX, y: newY });
  };

  const openWhatsApp = () => {
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
  };

  return (
    <motion.div
      drag
      dragMomentum={false}
      onDrag={handleDrag}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
      style={{
        position: 'fixed',
        left: position.x,
        top: position.y,
        zIndex: 9999,
        cursor: 'grab',
        touchAction: 'none', // ضروري للموبايل
      }}
    >
      <motion.button
        onClick={openWhatsApp}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        className="flex items-center justify-center shadow-lg"
        style={{
          width: buttonSize,
          height: buttonSize,
          backgroundColor: '#25D366', // لون واتساب الرسمي
          color: '#fff',
          border: '2px solid #1ebe5d',
          boxShadow: '0 4px 15px rgba(37, 211, 102, 0.4)',
          borderRadius: '50%', // ✅ تأكيد أن الزر دائري بالكامل
        }}
        aria-label="تواصل عبر واتساب"
      >
        <FaWhatsapp size={buttonSize * 0.55} color="#ffffff" />
      </motion.button>
    </motion.div>
  );
};

export default WhatsAppButton;
